import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class LoginRoute extends Route {
  // Services
  @service headData;
  @service intl;
  @service msal;
  @service session;

  // Hooks
  async beforeModel() {
    this.headData.title = this.intl.t('login.title');
    this.headData.favicon = 'login';
    const response = await this.msal.handleRedirect();
    if (response) {
      await this.session.authenticate('authenticator:microsoft', response);
    }
    this.session.prohibitAuthentication('admin.dashboard');
  }
}
